import * as Yup from "yup";

export function initialValues(student) {
  return {
    avatar: student?.avatar || "",
    fileAvatar: null,
    firstname: student?.name || "",
    lastname: student?.surname || "",
    email: student?.email || "",
    password: "",
    classnumber: student?.classnumber || "",
    active: student?.active !== undefined ? student.active : true,
  };
}

export function validationSchema(student, t) {
  return Yup.object({
    firstname: Yup.string().required(t("teachers:validation.nameRequired")),
    lastname: Yup.string().required(t("teachers:validation.lastNameRequired")),
    email: Yup.string()
      .email(t("teachers:validation.emailInvalid"))
      .required(t("teachers:validation.emailRequired")),
    password: student
      ? Yup.string()
      : Yup.string().required(t("teachers:validation.studentPasswordRequired")),
  });
}
